/**
 * Name of the cookie that stores the serialized auth tokens
 * (`{ token, refreshToken, tokenExpires }`).
 *
 * Shared between the client `AuthProvider` (which writes it via `js-cookie`)
 * and server-side code that needs to read the token to make authenticated
 * requests during render (e.g. payment-source prefetch). Keep both in sync.
 */
export const AUTH_TOKEN_COOKIE = "auth-token-data";
